import { render, staticRenderFns } from "./Subsanaciones.vue?vue&type=template&id=f4b27a82&"
import script from "./Subsanaciones.vue?vue&type=script&lang=js&"
export * from "./Subsanaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports